export function formatPrice(amount, currency) {
  const n = Number(amount || 0);
  const fixed = n.toFixed(currency.decimals);
  const [int, frac] = fixed.split('.');
  const intGrouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousandSep);
  const value = frac ? `${intGrouped}${currency.decimalSep}${frac}` : intGrouped;
  switch (currency.position) {
    case 'left': return `${currency.symbol}${value}`;
    case 'right': return `${value}${currency.symbol}`;
    case 'left_space': return `${currency.symbol} ${value}`;
    case 'right_space': return `${value} ${currency.symbol}`;
    default: return `${currency.symbol}${value}`;
  }
}

export function formatInches(value) {
  const n = Number(value || 0);
  return Number.isInteger(n) ? `${n}″` : `${n.toFixed(1).replace(/\.0$/, '')}″`;
}
